export default "__VITE_ASSET__DNBpZiP0__"